import { render, staticRenderFns } from "./UserWidgetPopover.vue?vue&type=template&id=21212722&scoped=true&"
import script from "./UserWidgetPopover.vue?vue&type=script&lang=js&"
export * from "./UserWidgetPopover.vue?vue&type=script&lang=js&"
import style0 from "./UserWidgetPopover.vue?vue&type=style&index=0&id=21212722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21212722",
  null
  
)

export default component.exports